import React from 'react';
import styles from 'Custom/Warnings/index.module.scss';
import Container from 'Nori/Container';
import RichText from 'Custom/RichText';
import ItemBreakpoint from 'Custom/ItemBreakpoint';
import Warningicon from 'Images/brand-icons/warning-icon.svg';

const ITEMS_LIST = [
  'Are pregnant or think you may be pregnant',
  'Have or have had blood clots, such as blood clots in your leg (deep vein thrombosis), lungs (pulmonary embolism), eyes (total or partial blindness), heart (heart attack), or brain (stroke)',
  'Have liver disease or a liver tumor',
  'Have unexplained vaginal bleeding',
  'Have breast cancer or any other cancer that is sensitive to progestin (a female hormone), now or in the past',
  'Are allergic to anything in NEXPLANON',
];

const TITLE = 'Don’t use NEXPLANON if you…';

const Warnings = ({
  className = '',
  title = TITLE,
  itemsList = ITEMS_LIST,
  children,
  ...props
}) => {
  return (
    <div data-qa-tag="warning-section" className={`${styles.wrapper} ${className}`} {...props}>
      <Container data-qa-tag="warning-container" size="md">
        <RichText data-qa-tag="warning-content-wrapper" className={styles.mainContainer}>
          <h2 data-qa-tag="warning-content-title">{title}</h2>
          <div className={styles.split}>
            <ItemBreakpoint>
              <>
                {itemsList && (
                  <div className={styles.splittedList}>
                    <ul className="">
                      {itemsList.slice(0, 2).map((item, i) => (
                        <li data-qa-tag="warning-list-item-A" key={`warnings-1${i}`}>
                          <Warningicon data-qa-tag="warning-list-icon-A" />
                          <p data-qa-tag="warning-list-description-A" className='body-text'>{item}</p>
                        </li>
                      ))}
                    </ul>
                    <ul className="">
                      {itemsList.slice(2, 6).map((item, i) => (
                        <li data-qa-tag="warning-list-item-B" key={`warnings-2-${i}`}>
                          <Warningicon data-qa-tag="warning-list-icon-B" /> <p data-qa-tag="warning-list-description-B">{item}</p>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
              <div className={styles.mobileList}>
                {itemsList && (
                  <ul className="">
                    {itemsList.map((item, i) => (
                      <li data-qa-tag="warning-list-mobile" key={`warnings-single${i}`}>
                        {' '}
                        <Warningicon data-qa-tag="warning-list-mobile-icon" /> <p data-qa-tag="warning-list-mobile-description">{item}</p>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </ItemBreakpoint>
          </div>
        </RichText>
      </Container>
    </div>
  );
};

export default Warnings;
